export default __webpack_public_path__ + "static/media/Breeches of the Black Pharaoh.00f5d8ae.jpg";